export const getKpiColor = (progress: number) => {
  if (progress >= 80) {
    return '#00B575'
  } else if (progress >= 31) {
    return '#FFBB38'
  } else {
    return '#8C2323'
  }
}

export const getKpiGradientColor = (progress: number) => {
  if (progress >= 80) {
    return 'linear-gradient(270deg, #00B575 0%, #006D47 100%)'
  } else if (progress >= 31) {
    return 'linear-gradient(180deg, #FFBB38 0%, #D88E00 100%)'
  } else {
    return 'linear-gradient(270deg, #8C2323 0%, #B52D2D 100%)'
  }
}
